/**
 * Remove registros duplicados preservando a ordem original.
 * Objetos são comparados a partir de uma serialização com chaves ordenadas,
 * garantindo que estruturas equivalentes (mesmo com ordem diferente de propriedades)
 * sejam consideradas iguais.
 *
 * @param {Array<any>} items - Lista original de registros.
 * @returns {Array<any>} - Lista contendo apenas registros únicos.
 */
export function dedupeBySerializedValue(items) {
  if (!Array.isArray(items)) return [];

  const seen = new Set();
  const unique = [];

  const serialize = (value) => {
    if (Array.isArray(value)) {
      return value.map(serialize);
    }

    if (value && typeof value === 'object') {
      const sortedKeys = Object.keys(value).sort();
      return sortedKeys.reduce((acc, key) => {
        acc[key] = serialize(value[key]);
        return acc;
      }, {});
    }

    return value;
  };

  for (const item of items) {
    const signature = JSON.stringify(serialize(item));
    if (!seen.has(signature)) {
      seen.add(signature);
      unique.push(item);
    }
  }

  return unique;
}

export default dedupeBySerializedValue;
